import React, { useState } from 'react';
import 'react-image-lightbox/style.css';
import Lightbox from 'react-image-lightbox';
import "./newsevent.css";


import CGimg1 from '../../assets/CG1.jpg';
import CGimg2 from '../../assets/CG2.jpg';
import CGimg3 from '../../assets/CG3.jpg';
import CGimg4 from '../../assets/CG4.jpg';
import CGimg5 from '../../assets/CG5.jpg';
import CGimg6 from '../../assets/CG6.jpg';
import CGimg7 from '../../assets/CG7.jpg';
import CGimg8 from '../../assets/CG8.jpg';
import CGimg9 from '../../assets/CG9.jpg';
import CGimg10 from '../../assets/CG10.jpg';
import CGimg11 from '../../assets/CG11.jpg';
import CGimg12 from '../../assets/CG12.jpg';
import CGimg13 from '../../assets/CG13.jpg';
import CGimg14 from '../../assets/CG14.jpg';
import CGimg15 from '../../assets/CG15.jpg';
import CGimg16 from '../../assets/CG16.jpg';
import CGimg17 from '../../assets/CG17.jpg';
import CGimg18 from '../../assets/CG18.jpg';



const sections = [
  {
   
    images: [CGimg1, CGimg2, CGimg3, CGimg4, CGimg5, CGimg6, CGimg7, CGimg8 , CGimg9, CGimg10, CGimg11, CGimg12 , CGimg13, CGimg14, CGimg15, CGimg16 , CGimg17 , CGimg18],
  },
];

const ChristmasGetTogether = () => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [currentImages, setCurrentImages] = useState([]);

  const openViewer = (images, index) => {
    setCurrentImages(images);
    setPhotoIndex(index);
    setIsViewerOpen(true);
  };

  const closeViewer = () => {
    setIsViewerOpen(false);
  };

  return (
    <div className="gallery">
      <h1 align="center">Christmas Get Together - 2023</h1>
      <p className="intro-third-christmas">Celebrated the Christmas holiday with students, colleagues, and friends at the Eye Care Christmas Get Together.</p>
      <br />
      {sections.map((section, sectionIndex) => (
        <div key={sectionIndex} className="gallery-section">
          <div className="gallery-header">
            <h2>{section.title}</h2>
          </div>
          <div className="gallery-grid">
            {section.images.map((src, index) => (
              <div key={index} className="gallery-item">
                <div className="overlay-container">
                <img
                    src={src}
                    alt={`Gallery item ${index + 1} in ${section.title}`} // Avoid the word "image"
                    className="gallery-image"
                    onClick={() => openViewer(section.images, index)}
                  />

                  <div className="overlay">
                    <button
                      className="max-view-button"
                      onClick={() => openViewer(section.images, index)}
                    >
                      <span>&#x2922;</span> {/* Fullscreen icon */}
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}

      {isViewerOpen && (
        <Lightbox
          mainSrc={currentImages[photoIndex]}
          nextSrc={currentImages[(photoIndex + 1) % currentImages.length]}
          prevSrc={
            currentImages[
              (photoIndex + currentImages.length - 1) % currentImages.length
            ]
          }
          onCloseRequest={closeViewer}
          onMovePrevRequest={() =>
            setPhotoIndex(
              (photoIndex + currentImages.length - 1) % currentImages.length
            )
          }
          onMoveNextRequest={() =>
            setPhotoIndex((photoIndex + 1) % currentImages.length)
          }
        />
      )}
    </div>
  );
};
export default ChristmasGetTogether